// Shared helpers for rendering submission file links. Extracted from the
// Submissions list "File" column so the same behaviour can be reused by the
// delete-confirmation modal without duplicating the URL logic.

/** True when the URL points at a SharePoint host (sharepoint.com or a subdomain). */
export function isSharepointUrl(value: string): boolean {
  try {
    const url = new URL(value);
    const hostname = url.hostname.toLowerCase();
    return hostname === "sharepoint.com" || hostname.endsWith(".sharepoint.com");
  } catch {
    return false;
  }
}

/** Derives a short uppercase label from a file URI's extension (e.g. "DOCX"). */
export function getFileTypeLabel(fileUri: string): string {
  try {
    const urlWithoutQuery = fileUri.split(/[?#]/)[0];
    const parts = urlWithoutQuery.split(".");
    const ext = parts.length > 1 ? parts[parts.length - 1] : "";
    return ext ? ext.toUpperCase() : "FILE";
  } catch {
    return "FILE";
  }
}

/**
 * Returns the URI to open in a new tab. SharePoint links get `web=1` appended so
 * they open in the browser viewer rather than triggering a download.
 */
export function buildFileDisplayUri(fileUri: string): string {
  if (!isSharepointUrl(fileUri)) {
    return fileUri;
  }
  return fileUri + (fileUri.includes("?") ? "&web=1" : "?web=1");
}
